import { logger } from "utils/logger";
import {
  fetchLatestAssets,
  getAssetsSuccess,
  selectAsset,
  setFeedFilter,
} from "../liveFeedSlice";

import { connect, useDispatch } from "react-redux";
import React, { useCallback, useEffect, useRef, useState } from "react";
import moment from "moment";
import LiveFeedAsset from "./LiveFeedAsset";
import {
  Box,
  CloseButton,
  Grid,
  Group,
  Image,
  Progress,
  Skeleton,
  Title,
} from "@mantine/core";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import styles from "./LiveFeed.module.scss";
import VerticalGenieNavigation from "./LiveFeedNav";
import LiveFeedAssetInfoPanel from "./LiveFeedAssetInfoPanel";
import _ from "lodash";
import { EmptyState } from "core/components/emptyState/EmptyState";
import DateFilterControl from "core/components/dateFilterPanel/DateFilterControl";
import { DateRanges, DateSelections, getDateRanges } from "utils/helper";

const LiveFeed = ({ asset, assets, selectAsset, feedFilter, setFeedFilter, user, success, error }) => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const location = useLocation();
  const [modalShown, setModalShown] = useState(false);
  const navigate = useNavigate();
  const [assetMap, setAssetMap] = useState({});
  const [doFetch, setDoFetch] = useState(true);

  const navRef = useRef(null);
  const mainContainerRef = useRef(null);
  const gridRef = useRef(null);


  logger.log(feedFilter)
  const onCloseClick = useCallback(() => {
    navigate("/feed");
  }, [navigate]);

  useEffect(() => {
    const handleEscKey = (event) => {
      if (event.key === "Escape") {
        console.log("Escape key was pressed!");

        onCloseClick();
        // Add your logic here for what should happen on ESC press
        // For example: close a modal, cancel an action, etc.
      }
    };

    // Add event listener when the component mounts
    document.addEventListener("keydown", handleEscKey);

    // Remove event listener when the component unmounts
    return () => {
      document.removeEventListener("keydown", handleEscKey);
    };
  }, [onCloseClick]);

  /**
   * Effect to fetch the talents
   */
  useEffect(() => {
    setIsLoading(true);
    logger.log('feed filter change')
    setTimeout(() => {
      const dayDate = feedFilter.dataFilter.dateRange.value[0];
      const dayStart = moment(dayDate).format("YYYY-MM-DD");
      const criteria = { dayStart: dayStart };
      dispatch(fetchLatestAssets(criteria));
    }, 100);
  }, [dispatch, feedFilter]);

  useEffect(() => {
    const buildAssetMap = () => {
      const map = {};
      // Create a map with asset.id as the key and the asset object as the value
      assets.forEach((asset) => {
        map[asset.id] = asset;
      });
      setAssetMap(map);
    };

    buildAssetMap();
  }, [assets]);

  useEffect(() => {
    if (success) {
      logger.log(success);
      switch (success.type) {
        // case bulkUpdateTalentsSuccess.toString():
        // case updateTalentSuccess.toString(): {
        //   dispatch(fetchTalents());
        //   break;
        // }
        case getAssetsSuccess.toString(): {
          setIsLoading(false);
          break;
        }
        default: {
          break;
        }
      }
    }
  }, [success]);

  const onItemClick = (item) => {
    logger.log(item, " ITEM CLICKED");
    // Create a new URLSearchParams object based on current search params
    const urlParams = new URLSearchParams(searchParams);

    // Only update if the item ID is different from current ID in URL or if asset doesn't exist
    if (
      (item && urlParams.get("id") && item.id !== urlParams.get("id")) ||
      !asset
    ) {
      // Set the new ID parameter
      urlParams.set("id", item.id);

      // Update the URL with the new search parameters
      setSearchParams(urlParams);
    }
  };

  useEffect(() => {
    const urlParams = new URLSearchParams(searchParams);
    if (urlParams.get("id")) {
      // grab the asset from the list

      if (assets) {
        //   const item = assets.find((val) => val.id === urlParams.get("id"));
        const item = assetMap[urlParams.get("id")];
        if ((item && asset && item.id !== asset.id) || (item && !asset)) {
          selectAsset(item);
          setModalShown(true);
        }
      }
    } else {
      selectAsset(null);
      setModalShown(false);
    }
  }, [location, assets, selectAsset, assetMap, searchParams, asset]);

  const onNavIndexChange = (newIdx, oldIdx) => {
    logger.log(newIdx, oldIdx);
    if (newIdx === oldIdx) return;
    if (assets && newIdx > -1) {
      const item = assets[newIdx];
      const urlParams = new URLSearchParams(searchParams);

      if (!item || (item && urlParams.get("id") === item.id)) return;

      // Set the new ID parameter
      urlParams.set("id", item.id);

      // Update the URL with the new search parameters
      setSearchParams(urlParams);
    }
  };

  const assetIndex =
    assets && asset
      ? _.findIndex(
          assets,
          (e) => {
            return e.id === asset.id;
          },
          0
        )
      : 0;

  const [progressValue, setProgressValue] = useState(0);

  // Function to handle wheel events from the main content
  const handleMainScroll = useCallback(
    (e) => {
      if (navRef.current && navRef.current.handleWheel && modalShown) {
        navRef.current.handleWheel(e.deltaY);
        // If you want to prevent the main window from scrolling when
        // handling these events, uncomment the next line:
        e.preventDefault();
      }
    },
    [modalShown]
  );

  const handleScroll = () => {
    if (mainContainerRef.current && gridRef.current) {
      const val =
        mainContainerRef.current.scrollTop / gridRef.current.offsetHeight;
      setProgressValue(val * 100);
    }
  };

  // Add scroll event listener
  useEffect(() => {
    const container = mainContainerRef.current;
    if (container) {
      container.addEventListener("scroll", handleScroll);

      // Clean up
      return () => {
        if (container) {
          container.removeEventListener("scroll", handleScroll);
        }
      };
    }
  }, []);

  useEffect(() => {
    // Add wheel event listener to main content
    const mainContent = document.querySelector(".main-content");
    if (mainContent) {
      mainContent.addEventListener("wheel", handleMainScroll, {
        passive: false,
      });
    }

    return () => {
      if (mainContent) {
        mainContent.removeEventListener("wheel", handleMainScroll);
      }
    };
  }, [modalShown, handleMainScroll]);




    /**
     * Effect to handle location change
     */
    useEffect(() => {
      const params = new URLSearchParams(location.search);
      
      // set the fetch status so we know what to pass to the criteria
      const weekstart = params.get("weekstart");
  
      // if (fetchStatus !== status) {
      //   setFetchStatus(status);
      // }
  
      if (weekstart) {
        // add seven days onto the date.
        var startDate = new Date(weekstart);
        startDate.setHours(0, 0, 0, 0);
  
        var endDate = new Date(startDate);
        endDate.setDate(startDate.getDate() + 0);
        endDate.setHours(23, 59, 59, 999);
  
        // if it's past the current date set it today
        const today = getDateRanges({ value: DateRanges.TODAY });
        if (endDate > today.endDate) {
          endDate = today.endDate;
        }
  
        if (startDate > today.startDate) {
          startDate = today.startDate;
        }
        var item;
  
        // check if the date is one of the predefined values
        switch (startDate.toDateString()) {
          case getDateRanges({
            value: DateRanges.TODAY,
          }).startDate.toDateString(): {
            item = DateSelections[0];
            break;
          }
          case getDateRanges({
            value: DateRanges.THIS_WEEK,
          }).startDate.toDateString(): {
            item = DateSelections[1];
            break;
          }
          case getDateRanges({
            value: DateRanges.LAST_WEEK,
          }).startDate.toDateString(): {
            item = DateSelections[2];
            break;
          }
          default: {
            var item = DateSelections[3];
            break;
          }
        }
  
        const dataFilter = {
          ...feedFilter.dataFilter,
          dateRange: {
            item: item,
            value: [startDate, endDate],
          },
        };
  
        if (
          JSON.stringify(dataFilter) !== JSON.stringify(feedFilter.dataFilter)
        ) {
          setFeedFilter({ ...feedFilter, dataFilter: dataFilter });
        }
        
      }
  
      logger.log("location change ", location, " DISPLAY: ", params);
      // if display type changes
      
    }, [location]);

  return (
    // <VerticalGenieNavigation assets={assets??[]} />
    <div
      style={{ position: "relative", flex: 1, height: "100%", display:'flex', flexDirection:'column' }}
      className="main-content"
    >
      {modalShown ? null : (
        <Progress
          value={progressValue}
          h={2}
          radius={0}
          style={{
            position: "absolute",
            top: 55,
            left: 0,
            right: 0,
            zIndex: 14,
            boxShadow:
              "0 3px 9px light-dark(rgba(0, 0, 0, .1),rgba(0, 0, 0, .4))",
          }}
        />
      )}

      <Group
        className="main-container-header"
        justify="space-between"
        align="center"
      >
        <Title order={3} lh={"lg"}>
          Latest Assets
        </Title>

        <DateFilterControl
          mode="single"
          filter={feedFilter}
          onApply={() => {
            setDoFetch(true);
          }}
        />
      </Group>
      <Box
        ref={mainContainerRef}
        px={"lg"}
        py={"lg"}
        style={{ overflow: modalShown ? "hidden" : "auto", flexGrow:1 }}
      >
        {!isLoading && assets && assets.length === 0 ? <EmptyState /> : null}
        {isLoading ? (
          <Grid gutter={1} h={"100%"}>
            {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((asset, idx) => {
              return (
                <Grid.Col key={asset} span={{ base: 12, md: 6, lg: 3 }}>
                  <React.Fragment key={idx}>
                    <Skeleton radius={0} width={"100%"} height={"200%"} />
                  </React.Fragment>
                </Grid.Col>
              );
            })}
          </Grid>
        ) : (
          <Grid gutter={1} ref={gridRef}>
            {assets?.map((asset, idx) => {
              return (
                <Grid.Col key={idx} span={{ base: 12, md: 6, lg: 3 }}>
                  <React.Fragment key={idx}>
                    <LazyLoadedImage asset={asset} onClick={onItemClick} />
                  </React.Fragment>
                </Grid.Col>
              );
            })}
          </Grid>
        )}
      </Box>

      {modalShown ? (
        <div className={styles.modal}>
          <div className={styles.modalContent}>
            <Grid style={{ height: "100%" }} mt={7}>
              <Grid.Col
                className={styles.imagePanel}
                style={{ height: "100%" }}
                span={{ base: 12, md: 6, lg: 8 }}
              >
                {asset ? (
                  <Group
                    justify="center"
                    style={{
                      height: "100%",
                      width: "100%",
                      position: "relative",
                      paddingTop: 32,
                      paddingBottom: 32,
                    }}
                  >
                    <div
                      onClick={() => onCloseClick()}
                      style={{
                        background: "rgba(255,255,255,0)",
                        position: "absolute",
                        top: 0,
                        bottom: 0,
                        left: 0,
                        right: 0,
                      }}
                    ></div>
                    <Image
                      src={asset.preview}
                      className={styles.previewImage}
                      fit="contain"
                    />
                  </Group>
                ) : null}

                <CloseButton
                  className={styles.closeBtn}
                  onClick={() => onCloseClick()}
                />
              </Grid.Col>
              <Grid.Col
                span={{ base: 12, md: 6, lg: 4 }}
                className={styles.assetPanel}
              >
                <Group>
                  {asset ? (
                    <LiveFeedAssetInfoPanel
                      style={{ styleNumber: asset.style }}
                      selectedItem={{ ...asset, styleNumber: asset.style }}
                      user={user}
                    />
                  ) : null}
                  <Box className={styles.navWrapper} visibleFrom="sm">
                    <VerticalGenieNavigation
                      assets={assets ?? []}
                      currentIndex={assetIndex}
                      onIndexChange={onNavIndexChange}
                      ref={navRef}
                    />
                  </Box>
                </Group>
              </Grid.Col>
            </Grid>
          </div>
        </div>
      ) : null}
    </div>
    // <ResponsiveMasonry
    //   columnsCountBreakPoints={{ 350: 1, 750: 3, 900: 4 }}
    //   gutterBreakpoints={{ 350: "12px", 750: "16px", 900: "2px" }}
    // >
    //   <Masonry gutter="0">
    //     {assets?.map((asset, idx) => {
    //       return (
    //         <React.Fragment key={idx}>
    //           <LazyLoadedImage asset={asset} />
    //         </React.Fragment>
    //       );
    //     })}
    //   </Masonry>
    // </ResponsiveMasonry>
  );
};

const mapStateToProps = (state, props) => {
  logger.log(state, props, " mapstate");
  return {
    user: state.auth.user,
    asset: state.liveFeedReducer.selectedAsset,
    assets: state.liveFeedReducer.assets,
    feedFilter: state.liveFeedReducer.feedFilter,
    success: state.liveFeedReducer.success,
    error: state.auth.error,
  };
};

const mapDispatchToProps = { selectAsset, setFeedFilter };

export default connect(mapStateToProps, mapDispatchToProps)(LiveFeed);

const LazyLoadedImage = ({ asset, ...props }) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const imgRef = useRef(null);
  const [isInView, setIsInView] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        const [entry] = entries;
        if (entry.isIntersecting) {
          setIsInView(true);
          // Once the image is loaded, you can optionally unobserve
          // observer.unobserve(entry.target);
        }
      },
      {
        rootMargin: "1200px", // This creates a buffer in all directions
        threshold: 0.01,
      }
    );
    const imageRef = imgRef.current;
    if (imageRef) {
      observer.observe(imageRef);
    }

    return () => {
      if (imageRef) {
        observer.unobserve(imageRef);
      }
    };
  }, []);

  // Render placeholder until in view
  return (
    <div
      ref={imgRef}
      className="lazy-image-container relative"
      style={{
        minHeight: "200px",
        height: "100%",
        width: "100%",
        flex: 1,
        position: "relative",
      }}
      onClick={() => props.onClick(asset)}
    >
      {isInView ? (
        <>
          <LiveFeedAsset
            asset={asset}
            onLoad={() => setTimeout(() => setIsLoaded(true), 1000)}
            {...props}
          />

          {!isLoaded ? (
            <Skeleton
              radius={0}
              style={{
                position: "absolute",
                zIndex: 2,
                top: 0,
                bottom: -1,
                left: 0,
                right: 0,
              }}
            />
          ) : null}
        </>
      ) : null}
    </div>
  );
};
